module.exports = __webpack_public_path__ + "static/media/fruit.0f09d3e2.png";